/** @jsx jsx */
import React from 'react'
import { forwardRef } from 'react'
import { jsx, useThemeUI } from 'theme-ui'
import { useComponent } from '../selectors'

// TODO: load this list from config
const parentIds = ['modularPage', 'richPage']

const ContainerDivStyle = ({ children, styling, variant }) => {
  const [, C] = useComponent({ tag: 'container' })
  return (
    <C className={''}>
      <div sx={{ variant, ...styling }}>{children}</div>
    </C>
  )
}

const DivStyle = ({ children, styling, variant }) => {
  return <div sx={{ variant, ...styling }}>{children}</div>
}

const TextContentDiv = ({ children }) => {
  const [, C] = useComponent({ tag: 'container' })
  const { theme } = useThemeUI()

  return (
    <C>
      <Choose>
        <When condition={theme?.layout?.container?.content?.contentStyle}>
          <div sx={{ variant: 'layout.container.content.contentStyle' }}>{children}</div>
        </When>
        <Otherwise>{children}</Otherwise>
      </Choose>
    </C>
  )
}

const Container = ({ children }) => {
  const [, C] = useComponent({ tag: 'container' })

  return (
    <C className={''} sx={{}}>
      {children}
    </C>
  )
}

const SmartContainer = forwardRef(
  (
    {
      parentContentType,
      wrapper,
      children,
      variant,
      styling = {},
      spacing = {},
      textContent = false,
      ...props
    },
    ref,
  ) => {
    const [, Palette] = useComponent({ tag: 'palette' })
    const parentIsRootEntity = parentIds.includes(parentContentType)
    // do not use container if useContainer is false
    const useContainer =
      (wrapper?.useContainer !== false || props?.useContainer) && parentIsRootEntity
    const useStyles = variant || Object.keys(styling).length > 0

    return (
      <Palette
        as='div'
        sx={parentIsRootEntity ? { ...spacing } : {}}
        px={{ backgroundColor: parentIsRootEntity ? 'backgroundColor' : '', color: 'textColor' }}
        {...props}
        ref={ref}
      >
        <Choose>
          {/*
        use TextContentDiv when textContent is true and useContainer is true
        This will ensure that text written directly into a rich page is put into the correct container
      */}
          <When condition={textContent && parentIsRootEntity}>
            <TextContentDiv>{children}</TextContentDiv>
          </When>
          {/*
        use ContainerDivStyle when the following are all true:
          - we have styles or a variant from contentful
          - the components parent is in the list of parentIDs
          - the wrapperConfig.useContainer is not explicitly false
      */}
          <When condition={useContainer && useStyles}>
            <ContainerDivStyle variant={variant} styling={styling}>
              {children}
            </ContainerDivStyle>
          </When>
          {/*
        use DivStyle when we have styles or a variant from contentful
        This could be used when there is a richText field as a child of
        a nested component
      */}
          <When condition={useStyles}>
            <DivStyle variant={variant} styling={styling}>
              {children}
            </DivStyle>
          </When>
          {/*
        use Container when the following are all true:
          - the components parent is in the list of parentIDs
          - the wrapperConfig.useContainer is not explicitly false
      */}
          <When condition={useContainer}>
            <Container>{children}</Container>
          </When>
          {/*
        Return children if non of the above apply
        If useContainer is false for example
       */}
          <Otherwise>{children}</Otherwise>
        </Choose>
      </Palette>
    )
  },
)

export default SmartContainer
